import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const Card = styled(Box)({
  backgroundColor: '#eceae4',
  borderRadius: '8px',
  padding: '13px 15px',
});

const Label = styled(Typography)({
  fontSize: '10px',
  color: '#6b6b68',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  fontFamily: '"SF Mono", "Fira Code", monospace',
  marginBottom: '6px',
});

const Value = styled(Typography)({
  fontSize: '24px',
  fontWeight: 500,
  lineHeight: 1,
  color: '#1a1a1a',
});

const ValueSuffix = styled('span')({
  fontSize: '14px',
  fontWeight: 400,
  color: '#6b6b68',
});

const SUB_COLORS = {
  pos: '#3B6D11',
  neg: '#993C1D',
  neu: '#6b6b68',
};

const Subtitle = styled(Typography)(({ subcolor }) => ({
  fontSize: '11px',
  fontFamily: '"SF Mono", "Fira Code", monospace',
  marginTop: '4px',
  color: SUB_COLORS[subcolor] || SUB_COLORS.neu,
}));

export default function KpiCard({ label, value, suffix, subtitle, subtitleColor = 'neu' }) {
  return (
    <Card>
      <Label>{label}</Label>
      <Value>
        {value}
        {suffix && <ValueSuffix> {suffix}</ValueSuffix>}
      </Value>
      {subtitle && <Subtitle subcolor={subtitleColor}>{subtitle}</Subtitle>}
    </Card>
  );
}
